// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"topTable_custom_table__2mA-n","nodata":"topTable_nodata__2iBkm"};